import { Config } from "../config/Config";
import { firestore, Timestamp } from "../utilities/Firebase";

/**
 * キャンペーンサービス
 */
export const CampaignService = () => {
    /**
     * Firestore からキャンペーン情報を取得する
     * @param id キャンペーンID
     * @return キャンペーン情報
     */
    const getCampaign = async (id: string) => {
        const path = Config.appEnv!;
        const doc = await firestore.collection(path).doc(id).get();

        if (!doc.exists) {
            throw new Error(`Firestor Campaign Document Not Found. path: ${path} id: ${id}`);
        }

        return doc.data();
    };

    /**
     * Firestoreから開催中のキャンペーン一覧を取得する
     * @returns 開催中のキャンペーンリスト
     */
    const getCampaignList = async () => {
        const path = Config.appEnv!;
        const currentTime = Timestamp.now();

        // 掲載期間中のキャンペーンを取得
        const snapshot = await firestore.collection(path)
            .where("endOfPublicationDatetime", ">=", currentTime)
            .get();
        const campaignList = snapshot.docs.map(doc => {
            return { id: doc.id, data: doc.data() };
        }).filter(campaignData => {
            // キャンペーンが開始している
            const isStarting = campaignData.data.from
                && (campaignData.data.from <= currentTime);
            // MMS対象のキャンペーンの場合
            // 削除対象でない
            // かつ　キャンペーン要素が確定している
            const isFixedContents =
                campaignData.data.isMMS &&
                !campaignData.data.isDeleated &&
                campaignData.data.createStepStatuses.fixContent === "ready";

            return campaignData.data.isMMS ? isFixedContents && isStarting : isStarting;
        }).sort((a, b) => {
            // キャンペーン開始日の昇順に並び替え
            return a.data.from - b.data.from
        });
        return campaignList;
    }

    /**
     * キャンペーン設定情報を取得する
     * @return キャンペーン設定
     */
    const getSetting = async () => {
        const path = Config.appEnv!;
        const doc = await firestore.collection(path).doc("Settings").get();
        return doc.data();
    }

    return { getCampaign, getCampaignList, getSetting };
};
